import { ChangeDetectionStrategy, Component, ElementRef, OnInit } from "@angular/core";
import { PortalService } from "../portal.service";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { ItemCategoriesSelectComponent } from "./item-categories-select/item-categories-select.component";
import { take } from "rxjs/operators";

@Component({
  selector: "ngx-item-categories-image",
  templateUrl: "./item-categories-image.component.html",
  styleUrls: ["./item-categories-image.component.scss"],
})
export class ItemCategoriesImageComponent extends BaseListComponent {
  constructor(public ps: PortalService, private el: ElementRef) {
    super();
  }

  ngOnInit() {}

  public openSelector(itemCategory): void {
    this.dialogService
      .open(ItemCategoriesSelectComponent, { itemCategory })
      .pipe(take(1))
      .subscribe((x) => {});
  }

}
